import Env from "../utils/env";
import { ISubscriptionPartnerInfo } from "../interfaces/subscriptions";
import { getUri, postUri } from "../utils/fetch";
import { IProjectChecklistResponse } from "../interfaces/projectChecklist";
import { getTaticIdObj } from "../utils/getTaticIdObj";
import { isEmpty } from "lodash";

export const getPartnerInfo = (signal: AbortSignal):  Promise<ISubscriptionPartnerInfo> => {
  const uri = Env.pfsAPIUrl.clone()
    .setPath(`${Env.pfsApiPrefix}/ps/partners/current`);
  return getUri(uri, {
    signal
  });
}
export const getProjectChecklist = (projectId: string, signal: AbortSignal):  Promise<IProjectChecklistResponse> => {
  const uri = Env.pfsAPIUrl.clone()
    .setPath(`${Env.pfsApiPrefix}/cs/projects/id/${projectId}/checklist/status`);
  return getUri(uri, {
    signal
  });
}

// Sends tatic Ids
export const syncTaticIds  = (certificationProjectId: string, status: "CERTIFICATION_STATUS_ARCHIVED") => {
  const uri = Env.pfsAPIUrl.clone()
    .setPath(`${Env.pfsApiPrefix}/ps/partners/events/sync`);
  const taticIds = getTaticIdObj();
  const payload = {
    certificationProjectId,
    status,
    ...taticIds,
  }
  if (!isEmpty(taticIds)) {
    void postUri(uri, payload);
  }
}
